import { api } from './api'
import type { BidType, TrumpSuit } from '../../../shared/types'

export interface ShareTokenResponse {
  token: string
}

export async function createShare(gameId: number): Promise<ShareTokenResponse> {
  const response = await api.post<ShareTokenResponse>(`/games/${gameId}/share`)
  return response.data
}

export interface ShareGamePlayer {
  userId: number
  position: number
  firstName: string
  totalScore: number
}

export interface ShareRound {
  roundNumber: number
  dealerId: number
  bidderId: number
  partnerId?: number
  bidType: BidType
  trumpSuit?: TrumpSuit
  tricksTaken: number
  won?: boolean
  score: number
}

export interface ShareGame {
  name: string
  date: string
  status: 'active' | 'completed'
  clubName: string | null
  players: ShareGamePlayer[]
  rounds: ShareRound[]
}

/** Henter et delt resultat. Offentligt endpoint, ingen session krævet. */
export async function getShare(token: string): Promise<ShareGame> {
  const response = await api.get<ShareGame>(`/share/${token}`)
  return response.data
}

/** Download-link til CSV-eksport af et enkelt spil. Sessionen sidder i en cookie, så et almindeligt link virker. */
export function gameExportCsvUrl(gameId: number): string {
  return `/api/games/${gameId}/export.csv`
}

/** Download-link til CSV-eksport af en klubs sæson. */
export function clubExportCsvUrl(clubId: number, year?: number): string {
  return `/api/clubs/${clubId}/export.csv${year ? `?year=${year}` : ''}`
}
